import type React from "react";
import { ReactComponent as Svg } from "./assets/time-clock-circle.svg";
import * as styles from "./Icon.module.scss";

type ClockProps = React.SVGProps<SVGSVGElement>;

export const Clock = ({ className, ...props }: ClockProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
